



































































import { Component, Vue, Prop } from 'vue-property-decorator';
import BeatLoader from 'vue-spinner/src/BeatLoader.vue';

interface QuestionIds {
  value: '';
  error: boolean | string;
}

@Component({
  components: { BeatLoader },
})
export default class UploadQuestionForm extends Vue {
  @Prop()
  objectiveIds!: QuestionIds;

  @Prop()
  subjectiveIds!: QuestionIds;

  @Prop()
  isSendLoading!: boolean;

  fetchQuestions() {
    this.$emit('fetchQuestions');
  }

  sendQuestions() {
    this.$emit('sendQuestions');
  }
}
